import { Injectable } from "@angular/core";
import { BasicResponse } from "src/app/core/models/basic-response.model";
import { getEndpoint } from "src/app/core/services/functions.service";
import { RequestsService } from "src/app/core/services/requests.service";



@Injectable({
    providedIn: 'root'
})
export class ReporteCartera {
    // ENDPOINT = 'http://localhost:8000'
    ENDPOINT = getEndpoint('reportes_cartera');

    

    constructor(private requestsService: RequestsService) {
    
    }
    
    async detalleCartera(company: string,cedula, cuenta): Promise<BasicResponse> {
        const res = await this.requestsService.get(`${this.ENDPOINT}/detalle_reporte/${cedula}/${cuenta}/${company}`);
        return res;
    }

    async HistoricaePagoDet(company: string, n_ide, factura): Promise<BasicResponse> {
        const res = await this.requestsService.get(`${this.ENDPOINT}/get_HistoricaPagoDet/${n_ide}/${factura}/${company}`);
        return res;
    }
    async DetalleCuota(company: string, n_ide, factura,cuenta): Promise<BasicResponse> {
        const res = await this.requestsService.get(`${this.ENDPOINT}/genDetCuotas/${n_ide}/${factura}/${cuenta}/${company}`);
        return res;
    }
    async ResDetalleCuota(company: string, cuenta, factura,agencia,tipo_credito): Promise<BasicResponse> {
        const res = await this.requestsService.get(`${this.ENDPOINT}/DetCuotas/${factura}/${cuenta}/${agencia}/${tipo_credito}/${company}`);
        return res;
    }
    async ResResumenCuenta(company: string, data: any): Promise<BasicResponse> {
        const res = await this.requestsService.postLikeJSON(`${this.ENDPOINT}/genResumenCuenta/${company}`, data);
        return res;
    }
}